module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--basic"
  }, [_c('sidebar', {
    attrs: {
      "user": _vm.user,
      "isFloating": true
    }
  }), _c('router-view', {
    staticClass: "page-view"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca343c32","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/BasicTemplate.vue
// module id = 1s9c
// module chunks = 1